var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-component-content",on:{"click":function($event){return _vm.rePortImageComponent()}}},[_c('img',{staticClass:"component-image",attrs:{"src":_vm.getPicUrl(_vm.activityComponentObj && _vm.activityComponentObj.jsonField && _vm.activityComponentObj.jsonField.picUrl)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-341075d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/vibrantRubikCube/runtime/activityManagementComponents/imagesComponent.vue
// module id = null
// module chunks = 